import styled from "styled-components";

import { colors } from "shared/ui/tokens";

/*
* Полоса табов кита рассчитана на страницу — под ней 24px отступа, и вместе с зазором
* тела модалки получалось около 40px пустоты. Селектор по потомку, а не styled(Tabs):
* у обёртки над компонентом кита класс может оказаться в таблице стилей раньше
* собственного, и переопределение молча не применится.
* */
export const TabsRow = styled.div`
    > div {
        margin-bottom: 0;
    }
`;

export const TabPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-bottom: 12px;
    /* Вкладки разной высоты (одно поле против семи дней или сотни позиций) — фиксируем
       минимум, иначе модалка прыгает при каждом переключении. */
    min-height: 260px;
`;

export const LanguageRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Hint = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

// Удаление стоит слева, отдельно от «Отмена / Сохранить»: это выход из формы, а не
// один из вариантов её завершения.
export const ActionsSpacer = styled.div`
    flex: 1 1 auto;
`;
